import classNames from 'classnames';
import { Spin, SpinSize } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Loader.css';

export enum LoaderTheme {
    white = 'white'
}

export interface LoaderProps {
    cls?: string;
    size: SpinSize;
    text?: string;
    theme?: LoaderTheme;
}

const block = 'loader';

export const Loader = ({ size, text, cls, theme }: LoaderProps) => (
    <div
        className={classNames(
            Bem.cls({
                block: block,
                mods: {
                    theme: theme ? theme : false
                }
            }),
            cls
        )}
    >
        <Spin progress={true} size={size} cls={Bem.cls(block, 'spin')} />

        {text && <div className={Bem.cls(block, 'text')}>{text}</div>}
    </div>
);
